var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.8,
    height: 56.474,
    viewBox: "0 0 153.8 56.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 153.8,
    height: 56.474,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M89.972,29.487c-5.245,0-8.939-4.388-8.939-10.007v-.108c0-5.458,3.693-9.9,8.939-9.9,3.585,0,6.047,1.713,8.187,4.388l7.814-6.047C102.656,3.21,97.73,0,90.08,0a19.332,19.332,0,0,0-18,11.252C69,4.591,62.163,0,53.725,0,44.608,0,37.292,5.429,34.606,13,32.133,5.6,25.062.749,14.449.749H0V38.211H14.236c10.607,0,17.732-4.968,20.3-12.346,2.6,7.642,9.895,13.094,19.088,13.094a19.979,19.979,0,0,0,18.4-11.246A19.018,19.018,0,0,0,89.651,38.959c8.3,0,13.06-3.585,16.59-8.455l-7.814-5.566c-2.248,2.728-4.548,4.548-8.455,4.548M24.939,19.534c0,6.046-4.121,9.471-10.328,9.471H10.383V9.954h4.228c6.207,0,10.328,3.478,10.328,9.473Zm38.313.053c0,5.405-3.8,10.007-9.527,10.007-5.673,0-9.579-4.709-9.579-10.114v-.108c0-5.405,3.8-10.007,9.473-10.007,5.725,0,9.633,4.709,9.633,10.115Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 10.437,
    height: 37.462,
    transform: "translate(107.202 0.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M476.488,20.68c3.316-1.444,5.779-4.013,5.779-8.349v-.107a8.219,8.219,0,0,0-2.409-6.047c-2.194-2.194-5.513-3.372-10.222-3.372H450.424V40.268h19.319c8.937,0,14.183-3.908,14.183-10.33v-.106c0-5.084-2.891-7.654-7.438-9.152m-15.949-9.526h6.743c3.1,0,4.709,1.177,4.709,3.211v.108c0,2.194-1.765,3.265-4.923,3.265h-6.53Zm13.005,17.339c0,2.2-1.821,3.425-4.979,3.425h-8.027v-6.9h7.921c3.477,0,5.084,1.337,5.084,3.372Z",
    transform: "translate(-330.125 -2.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1.439,178.383h3.25c1.96,0,3.25,1.042,3.25,2.753v.025c0,1.873-1.563,2.841-3.411,2.841H2.419v3.064h-.98Zm3.126,4.726c1.439,0,2.382-.769,2.382-1.911v-.024c0-1.24-.93-1.886-2.332-1.886h-2.2v3.821Z",
    transform: "translate(-1.055 -130.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M75.2,178.383h.98v3.858H81.2v-3.858h.98v8.683H81.2v-3.907H76.184v3.907H75.2Z",
    transform: "translate(-55.119 -130.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M154.413,178.15h.918l3.957,8.745h-1.055l-1.017-2.3H152.49l-1.03,2.3h-1Zm2.419,5.57-1.973-4.428-1.985,4.428Z",
    transform: "translate(-110.272 -130.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M232.673,178.383h3.733a3.423,3.423,0,0,1,2.469.868,2.4,2.4,0,0,1,.67,1.712v.025a2.541,2.541,0,0,1-2.357,2.53l2.667,3.548h-1.2l-2.518-3.374h-2.48v3.374h-.98Zm3.647,4.428c1.3,0,2.232-.67,2.232-1.786V181c0-1.066-.819-1.712-2.221-1.712h-2.679v3.523Z",
    transform: "translate(-170.531 -130.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M308.991,178.383h.992l3.163,4.738,3.164-4.738h.992v8.683h-.98v-7.033l-3.163,4.652h-.049l-3.163-4.639v7.021h-.955Z",
    transform: "translate(-226.466 -130.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M393.217,178.15h.918l3.957,8.745h-1.054l-1.018-2.3h-4.726l-1.03,2.3h-1Zm2.419,5.57-1.972-4.428-1.985,4.428Z",
    transform: "translate(-285.296 -130.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M468.135,182.34v-.025a4.375,4.375,0,0,1,4.391-4.49,4.521,4.521,0,0,1,3.387,1.377l-.67.72a3.772,3.772,0,0,0-2.729-1.191,3.4,3.4,0,0,0-3.361,3.56v.024a3.426,3.426,0,0,0,3.361,3.585,3.769,3.769,0,0,0,2.8-1.253l.645.633a4.521,4.521,0,0,1-3.474,1.526,4.331,4.331,0,0,1-4.354-4.466",
    transform: "translate(-343.106 -130.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M546.391,183.629l-3.609-5.247h1.191l2.927,4.341,2.952-4.341h1.141l-3.61,5.235v3.449h-.992Z",
    transform: "translate(-397.816 -130.74)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.10a3fbdccb14eabda9a98e7c20aae33b.svg";
export { ForwardRef as ReactComponent };